/**
 * Formes de sortie de l'API, consommées telles quelles par les deux fronts.
 *
 * Les dates sont sérialisées en ISO 8601 (string) et non en `Date` : c'est ce
 * que produit `JSON.stringify` côté NestJS, autant que le type le reflète.
 */
/** Fenêtre glissante d'observation de la récurrence, en jours. */
export const ALERT_RECURRENCE_WINDOW_DAYS = 30;
/** Événements poussés par le gateway WebSocket (§5.1 étape 5). */
export const REALTIME_EVENTS = {
    alertCreated: 'alert.created',
    alertUpdated: 'alert.updated',
    applianceStatusChanged: 'appliance.status_changed',
};
//# sourceMappingURL=views.js.map